import image01 from '../images/content-master/orco1.jpg';
import image02 from '../images/content-master/orco2.jpeg';
import image03 from '../images/content-master/orco3.png';
import image04 from '../images/content-master/orco4.jpeg';
import image05 from '../images/content-master/SpaceWarrior.jpg';

import zbrush from '../images/technologies/zbrush.png';
import maya from '../images/technologies/maya.png';
import marmoset from '../images/technologies/marmoset.png';
import substance1 from '../images/technologies/substance.png';
import substance2 from '../images/technologies/substance3.png';
import unreal from '../images/technologies/unreal.png';

// let substance;

const contentMaster = [
	{
		id: '01',
		title: 'Escultura avanzada',
		image: image01,
		imageWebp: image01,
		description:
			'Crearemos este sorprende modelos para animación y cine con certificación universitaria y acompañamiento online en vivo.',
		video: '',
		software: [zbrush, maya, substance1, marmoset],
	},
	{
		id: '02',
		title: 'Space Warrior',
		image: image05,
		imageWebp: image05,
		description: 'Crea este sorprendente personaje y domina la escultura Hardsurface en ZBrush.',
		video: '',
		software: [zbrush],
	},
	{
		id: '03',
		title: 'Domina la escultura HARDSURFACE',
		image: image02,
		imageWebp: image02,
		description: 'Aprende y desarrolla sorprendentes técnicas de escultura inorgánica en ZBRUSH.',
		video: 'https://www.youtube.com/watch?v=RnFm-puWjYU',
		software: [zbrush, maya, marmoset],
	},
	{
		id: '04',
		title: 'Escultura Realista',
		image: image03,
		imageWebp: image03,
		description:
			'Crear modelos realistas es un gran reto que con nuestros entrenamiento lo podrás lograr, es momento de avanzaren tu carrera profesional.',
		video: 'https://www.youtube.com/watch?v=k9U0_3eSyXA',
		software: [zbrush, maya, substance1, marmoset],
	},
	{
		id: '05',
		title: 'Escultura de fantástica',
		image: image04,
		imageWebp: image04,
		description:
			'Desarrollaremos esta excelente escultura en ZBrush donde aprenderás la importancia del detalle en la escultura digital.',
		video: 'https://www.youtube.com/watch?v=x4p2eu-6U_Q',
		software: [zbrush, maya, substance1, marmoset, unreal],
	},
];

export default contentMaster;
